"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameService = void 0;
var _environment = require("../environment");
var _http = require("./http");
var _user = require("./user");
class GameService {
  static async getGame(id, {
    query
  }) {
    try {
      const res = await _http.HttpService.get('v1', `/games/${id}`, [{
        key: 'query',
        value: query
      }]);
      return parseGame(res);
    } catch (err) {
      console.error('[GameService][getGame]', err);
      throw err;
    }
  }
  static async createPlayer(game) {
    if (!_user.UserService.currentUser) throw new Error('user not connected');
    try {
      const data = await _http.HttpService.post('v1', `/games/${game.id}/players`, [{
        key: 'game_id',
        value: game.id
      }, {
        key: 'user_id',
        value: _user.UserService.currentUser.id
      }]);
      return parseGamePlayer(game.theme, data);
    } catch (err) {
      console.error('[GameService][createPlayer]', err);
      throw err;
    }
  }
  static async getPlayer(game, {
    query
  }) {
    if (!_user.UserService.currentUser) throw new Error('user not connected');
    try {
      const {
        results: [res]
      } = await _http.HttpService.get('v1', `/user_games`, [{
        key: 'game_ids',
        value: game.id
      }, {
        key: 'page',
        value: 1
      }, {
        key: 'page_size',
        value: 1
      }, {
        key: 'query',
        value: query
      }]);
      return res ? parseGamePlayer(game.theme, res) : null;
    } catch (err) {
      console.error('[GameService][getPlayer]', err);
      throw err;
    }
  }
  static async getTeams(gameId, {
    query
  }) {
    try {
      const {
        results
      } = await _http.HttpService.get('v1', `/games/${gameId}/teams`, [{
        key: 'ordering',
        value: 'leaderboard_index'
      }, {
        key: 'page',
        value: 1
      }, {
        key: 'page_size',
        value: 100
      }, {
        key: 'query',
        value: query
      }]);
      return results.reduce((res, data) => {
        const team = parseTeam(data);
        if (team) res.push(team);
        return res;
      }, []);
    } catch (err) {
      console.error('[GameService][getTeams]', err);
      throw err;
    }
  }
  static async getTiles(gameId, {
    bounds
  } = {}) {
    try {
      const queryParams = [];
      if (bounds) {
        const {
          north,
          east,
          south,
          west
        } = bounds;
        queryParams.push({
          key: 'north',
          value: north
        }, {
          key: 'east',
          value: east
        }, {
          key: 'south',
          value: south
        }, {
          key: 'west',
          value: west
        });
      }
      const res = await _http.HttpService.get('v1', `/games/${gameId}/tile_states`, queryParams);
      return res.reduce((res, data) => {
        const tileState = parseTile(data);
        if (tileState) res.push(tileState);
        return res;
      }, []);
    } catch (err) {
      console.error('[GameService][getTiles]', err);
      throw err;
    }
  }
  static async getLeaderboard(game, {
    page,
    pageSize,
    query
  }) {
    try {
      const {
        count,
        results
      } = await _http.HttpService.get('v1', `/games/${game.id}/players`, [{
        key: 'ordering',
        value: 'leaderboard_index'
      }, {
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }, {
        key: 'query',
        value: query
      }]);
      return {
        count,
        leaderboard: results.reduce((res, data) => {
          const player = parseGamePlayer(game.theme, data);
          if (player) res.push(player);
          return res;
        }, [])
      };
    } catch (err) {
      console.error('[GameService][getLeaderboard]', err);
      throw err;
    }
  }
}
exports.GameService = GameService;
const gameThemesMap = {
  CHRISTMAS_V1: 'christmasV1',
  HALLOWEEN_V1: 'halloweenV1'
};
function parseGame({
  theme: _theme,
  id,
  title,
  mode,
  description,
  photo,
  start_datetime,
  end_datetime,
  team_assignation_mode,
  covered_zone,
  last_processed_trace_creation_time,
  pmtiles_file
}) {
  const theme = _theme && gameThemesMap[_theme];
  if (!theme) throw new Error('empty or unknown theme');
  const startDate = start_datetime ? new Date(start_datetime) : null;
  const endDate = end_datetime ? new Date(end_datetime) : null;
  if (startDate) startDate.setHours(0, 0, 0);
  if (endDate) endDate.setHours(23, 59, 59);
  return {
    id: id || -1,
    title: title || null,
    theme,
    mode: mode || null,
    description: description || null,
    photo: photo ? `${_environment.defaultEnvironment.backendUrl}${photo}` : null,
    startDate,
    endDate,
    teamAssignationMode: team_assignation_mode === 'MANUAL_USER_CHOOSE_TEAM' ? 'manual' : 'automatic',
    coveredZone: covered_zone || null,
    lastProcessedTraceCreationTime: last_processed_trace_creation_time ? new Date(last_processed_trace_creation_time) : null,
    pmTilesFileUrl: pmtiles_file ? `${_environment.defaultEnvironment.backendUrl}${pmtiles_file.trim()}` : null
  };
}
function parseTeam({
  id,
  title,
  color,
  photo,
  icon,
  rank,
  leaderboard_index,
  score
}) {
  if (!id) return null;
  return {
    id,
    title: title || null,
    color: color || null,
    photo: photo ? `${_environment.defaultEnvironment.backendUrl}${photo}` : null,
    icon: icon ? `${_environment.defaultEnvironment.backendUrl}${icon}` : null,
    rank: rank || null,
    leaderboardIndex: leaderboard_index || null,
    score: score || 0
  };
}
function parseTile({
  h3_index,
  team,
  metadata
}) {
  if (!h3_index) return null;
  return {
    h3Index: h3_index,
    teamId: team || null,
    metadata: metadata || null
  };
}
function parseGamePlayer(theme, {
  id,
  team,
  rank,
  leaderboard_index,
  score,
  user,
  metadata
}) {
  if (!id) return null;
  return {
    id,
    teamId: team?.id || -1,
    rank: rank || null,
    leaderboardIndex: leaderboard_index || null,
    score: score || 0,
    username: user?.username || `Player ${id}`,
    profilePicture: user?.profile_picture ? `${_environment.defaultEnvironment.backendUrl}${user.profile_picture}` : null,
    metadata: metadata && theme === 'christmasV1' ? {
      christmasV1: {
        gifts: new Array(24).fill(null).map((_, index) => {
          const count = metadata[`present_${index + 1}`];
          if (typeof count === 'number') return count;
          return 0;
        })
      }
    } : {}
  };
}